





















































































































































































































































































import FooterButton from "@/components/FooterButton.vue";
import { Component, Mixins } from "vue-property-decorator";
import { AppData } from "@/models/app-data";
import CommonMixin, { County } from "@/mixins/common-mixins";
import { ContentService } from "@/service/content.service";
import { AlternateGSRPQualifierList2Content } from "@/models/content/alternate-gsrp-qualifier-list-2";
import { matchQualifiers, QualifierRule } from "@/models/rules";

@Component({
  components: {
    FooterButton,
  },
})
export default class AlternateGSRPQualifierList2 extends Mixins(CommonMixin) {
  content: AlternateGSRPQualifierList2Content = {} as AlternateGSRPQualifierList2Content;
  PercentDone = 80;
  disabilityChecked = false;
  expelledChecked = false;
  englishSecondChecked = false;
  noEnglishHomeChecked = false;
  parentalLossChecked = false;
  toxicExposureChecked = false;
  sexualAbuseChecked = false;
  neglectChecked = false;
  protectiveServicesChecked = false;
  under20BirthChecked = false;
  highRiskNeighborhoodChecked = false;
  siblingIssueChecked = false;
  noneChecked = false;
  appData = {} as AppData;
  textDirection = "ltr";
  checkTextAlign = "has-text-left";

  async mounted(): Promise<void> {
    try {
      const contentService = new ContentService(this.$route);
      this.content = await contentService.getAlternateGSRPQualifierList2();
      this.textDirection = contentService.TextDirection();
      if (this.textDirection == "rtl") {
        this.checkTextAlign = "has-text-right";
      }
      this.appData = this.getAppData();

      if (this.appData != null) {
        this.disabilityChecked = this.appData.disability;
        this.expelledChecked = this.appData.expelled;
        this.englishSecondChecked = this.appData.englishSecond;
        this.noEnglishHomeChecked = this.appData.noEnglishHome;
        this.parentalLossChecked = this.appData.parentalLoss;
        this.toxicExposureChecked = this.appData.toxicExposure;
        this.sexualAbuseChecked = this.appData.sexualAbuse;
        this.neglectChecked = this.appData.neglect;
        this.protectiveServicesChecked = this.appData.protectiveServices;
        this.under20BirthChecked = this.appData.under20Birth;
        this.highRiskNeighborhoodChecked = this.appData.highRiskNeighborhood;
        this.siblingIssueChecked = this.appData.siblingIssue;
        this.noneChecked = this.appData.gsrpQualifierList2None;
        this.putWorkflowStep( this.appData.workflowId, "AlternateGSRPQualifierList2") 
      }
    } catch (error) {
      this.showError(error);
    }
  }

  optionChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked === true) {
      this.noneChecked = false;
    }
  }

  noneChanged(e: { target: HTMLInputElement }): void {
    if (this.noneChecked == true) {
      this.disabilityChecked = false;
      this.expelledChecked = false;
      this.englishSecondChecked = false;
      this.noEnglishHomeChecked = false;
      this.parentalLossChecked = false;
      this.toxicExposureChecked = false;
      this.sexualAbuseChecked = false;
      this.neglectChecked = false;
      this.protectiveServicesChecked = false;
      this.under20BirthChecked = false;
      this.highRiskNeighborhoodChecked = false;
      this.siblingIssueChecked = false;
    }
  }

  public handleNextPageEvent(): void {
    if (this.appData == null) {
      this.appData = {} as AppData;
    }
    this.appData.disability = this.disabilityChecked;
    this.appData.expelled = this.expelledChecked;
    this.appData.englishSecond = this.englishSecondChecked;
    this.appData.noEnglishHome = this.noEnglishHomeChecked;
    this.appData.parentalLoss = this.parentalLossChecked;
    this.appData.toxicExposure = this.toxicExposureChecked;
    this.appData.sexualAbuse = this.sexualAbuseChecked;
    this.appData.neglect = this.neglectChecked;
    this.appData.protectiveServices = this.protectiveServicesChecked;
    this.appData.under20Birth = this.under20BirthChecked;
    this.appData.highRiskNeighborhood = this.highRiskNeighborhoodChecked;
    this.appData.siblingIssue = this.siblingIssueChecked;
    this.appData.gsrpQualifierList2None = this.noneChecked;

    this.saveAppData(this.appData);

    const oneOrMoreApplies =
      this.disabilityChecked === true ||
      this.expelledChecked === true ||
      this.englishSecondChecked === true ||
      this.parentalLossChecked === true ||
      this.noEnglishHomeChecked === true ||
      this.toxicExposureChecked === true ||
      this.sexualAbuseChecked === true ||
      this.neglectChecked === true ||
      this.protectiveServicesChecked ===true ||
      this.under20BirthChecked === true ||
      this.highRiskNeighborhoodChecked === true ||
      this.siblingIssueChecked === true;

    if (this.allChildren4AndOver(this.appData)) {
      this.handleAllFourAndOver(oneOrMoreApplies);
    } else if (this.childrenBothOverAndUnder4(this.appData)) {
      this.handleBothUnderAndOverFour(oneOrMoreApplies);
    }
  }

  handleAllFourAndOver(oneOrMoreApplies: boolean): void {
    const rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Macomb, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Oakland, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [true, County.Washtenaw, undefined], path: 'MatchGSRPReferral' }
        ,{ index: [false, County.Wayne, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Macomb, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Oakland, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Washtenaw, undefined], path: 'MatchNone' }
    ]

    const rule = matchQualifiers(rules, oneOrMoreApplies, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  handleBothUnderAndOverFour(oneOrMoreApplies: boolean): void {
    const rules: QualifierRule[] = [
        { index: [true, County.Wayne, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Macomb, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Oakland, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [true, County.Washtenaw, undefined], path: 'MatchNoneAndGSRPReferral' }
        ,{ index: [false, County.Wayne, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Macomb, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Oakland, undefined], path: 'MatchNone' }
        ,{ index: [false, County.Washtenaw, undefined], path: 'MatchNone' }
    ]

    const rule = matchQualifiers(rules, oneOrMoreApplies, this.appData.county, this.appData.fpl)
    if (rule == null) {
        this.$router.push({ path: 'MatchNone' });
        return;
    }
    this.$router.push({ path: rule.path });
  }

  disableNext(): boolean {
    return !(
      this.disabilityChecked ||
      this.expelledChecked ||
      this.englishSecondChecked ||
      this.parentalLossChecked ||
      this.noEnglishHomeChecked ||
      this.toxicExposureChecked ||
      this.sexualAbuseChecked ||
      this.neglectChecked ||
      this.protectiveServicesChecked ||
      this.under20BirthChecked ||
      this.highRiskNeighborhoodChecked ||
      this.siblingIssueChecked ||
      this.noneChecked
    );
  }
}
